<template>

  <div class="g-video w1200">

    <h3 class="title">
      {{ studyDetail.courseName }}
      <span v-if="studyDetail.courseName && currentCourseChapterName && currentCourseChapterName !== studyDetail.courseName">：</span>
      <span v-if="currentCourseChapterName && currentCourseChapterName !== studyDetail.courseName">{{ currentCourseChapterName }}</span>
    </h3>
    <div class="videoBox">
      <!-- <video :src="videoSrc" controls="controls"></video> -->
      <video class="my-video video-js vjs-big-play-centered" id="my-video" controls="controls"></video>
      <div class="detailList">
        <!-- 右侧tab -->
        <div class="tab">
          <span v-for="( item, index ) in detailList" :key="index" :class="item.className" @mouseenter="changeTab( index, 'detailList' )">{{ item.name }}</span>
        </div>
        <!--
          课程章节
          TODO：免费标签后台暂未实现
        -->
        <GeminiScrollbar class="my-scroll-bar">
          <ul v-if="studyType">
            <li v-for="( item, index ) in studyList" :class="[ chapterId == item.id ? 'active' : '' ]" :key="index" @click="handleChangeChapter( item.id )">
              <div>
                <p>{{ item.name }}</p>
                <div>
                  <span class="time">{{ item.duration | second2minute }}分钟</span>
                  <!-- <span class="studyType">{{ item.studyType }}</span> -->
                </div>
              </div>
            </li>
          </ul>
          <!-- 相关资料 -->
          <ul v-if="!studyType">
            <li v-for="( item, index ) in pdfList" :key="index" @click="toPdfDetail( item )">
              <p>{{ item.datumName }}</p>
              <div>
                <span class=" pdfType">
                  <span class="s1">.{{ item.type }}</span>
                  <span class="s2">{{ item.readCount }}人阅读</span>
                </span>
              </div>
            </li>
          </ul>
        </GeminiScrollbar>

        <!-- <div class="toPage">
          <i class="el-icon-arrow-up"></i>
          <i class="el-icon-arrow-down"></i>
        </div> -->

      </div>
    </div>
    <!-- 课程详情 -->
    <div class="videoInfo">
      <ul>
        <li v-for="( item, index ) in liList" :key="index" :class="item.className" @click="onVideoInfo( index )">
          <i :class="item.i"></i>
          <span>{{ item.name }}</span>
        </li>
        <div class="icoList" v-if="icoType">
          <span v-for="( item, index ) in icoList" :key="index">
            <img :src="item" alt="">
          </span>
        </div>
      </ul>
    </div>
    <div class="downBody">
      <div class="introduce">
        <!-- 课程详情 tab -->
        <div class="introduceTab">
          <span v-for="(item,index) in introduceTap" :key='index' :class="item.className" @mouseenter="changeTab(index,'introduceTap')">
            {{ item.name }}
          </span>
        </div>
        <pre v-if="preType1">{{ studyDetail.courseIntroduce }}</pre>
        <pre v-if="preType2">{{ studyDetail.courseTarget }}</pre>
        <!-- 讲师介绍 -->
        <div class="teacher" v-if="preType3">
          <div class="teacherImg">
            <img :src="courseTeacher.avatar" alt="">
            <span>
              <p class="p1">{{ courseTeacher.nickName }}</p>
              <p class="p2">{{ courseTeacher.title }}</p>
            </span>
          </div>
          <p class="teacherP">{{ courseTeacher.info }}</p>
        </div>
        <CommentModule ref="CommentModule" />
      </div>
      <!-- 相关课程 -->
      <div class="correlated">
        <p v-if="correlatedList.length > 0" class="titleP">相关课程</p>
        <ul v-if="correlatedList.length > 0" class="list-box">
          <li v-for="( item, index ) in correlatedList" :key="index" @click="toDetail( item.courseId )">
            <a>
              <div class="img-box">
                <img :src="item.courseCover | getCourseCoverUrl" alt="">
                <span>{{ item.lessonCount }}课时</span>
              </div>
              <p>{{ item.courseName }}</p>
              <div>
                <span class="sort foot">类别:{{ item.displayCategory }}</span>
                <span class="player foot">播放数：{{ item.studyCount }}次</span>
              </div>
            </a>
          </li>
        </ul>

      </div>
    </div>

  </div>

</template>

<script>
/* global $http */
/* global _ */
/* global videojs */
/* global gotoLogin */
/* global YitongToken */

import CommentModule from 'src/components/commentModule.vue'

export default {
  name: 'video',
  components: { CommentModule },
  data() {
    return {
      studyDetail: {},
      studyType: true,
      icoType: false,
      correlatedList: [],
      pdfList: [],
      studyList: [],
      preType1: true,
      preType2: false,
      preType3: false,
      // 章节id
      chapterId: null,
      // 视频tab
      detailList: [
        {
          name: '课程章节',
          className: 'on'
        },
        {
          name: '相关资料',
          className: ''
        }
      ],
      introduceTap: [
        {
          name: '课程介绍',
          className: 'on',
          pre: 'preType1'
        },
        {
          name: '课程目标',
          className: '',
          pre: 'preType2'
        },
        {
          name: '讲师介绍',
          className: '',
          pre: 'preType3'
        }
      ],
      icoList: [
        'http://image.yitong.com/www/g/share/tsina.jpg',
        'http://image.yitong.com/www/g/share/tqq.jpg',
        'http://image.yitong.com/www/g/share/qzone.jpg',
        'http://image.yitong.com/www/g/share/sqq.jpg',
        'http://image.yitong.com/www/g/share/weixin.jpg',
        'http://image.yitong.com/www/g/share/douban.jpg',
        'http://image.yitong.com/www/g/share/renren.jpg'
      ],

      //
      liList: [
        {
          className: '',
          name: '观看',
          i: 'el-icon-view'
        },
        {
          className: '',
          name: '讨论',
          i: 'el-icon-tickets'
        },
        {
          className: '',
          name: '课程收藏',
          i: 'el-icon-star-off'
        }
        // TODO：
        // {
        //   className: '',
        //   name: '分享到',
        //   i: 'el-icon-share'
        // }
      ],

      // 教师信息
      courseTeacher: {},

      // 当前章节名
      currentCourseChapterName: ''
    }
  },
  computed: {},
  mounted() {
    this.courseId = this.$route.query.courseId || ''

    this.getPdfList()
    this.getStudyList()
    this.getVideoDetail().then(() => {
      this.getCorrelatedList()
    })

    this.$refs.CommentModule.init({
      courseId: this.courseId
    })
  },
  methods: {
    /**
     * 获取课程详情
     */
    getVideoDetail() {
      return $http
        .post('/yswx/gw/videoCourse/getCourseDetailForPC', {
          courseId: this.courseId
        })
        .then(data => {
          const _result = data.result

          this.studyDetail = Object.assign(this.studyDetail, _result)

          this.courseTeacher = {
            avatar:
              _.get(_result, 'courseTeacher[0].avatar') ||
              'https://public.yitong.com/images/yitong-avatar.png',
            nickName: _.get(_result, 'courseTeacher[0].nickName') || '',
            title: _.get(_result, 'courseTeacher[0].title') || '',
            info: _.get(_result, 'courseTeacher[0].info') || ''
          }

          this.liList[0].name = `${_result.studyCount}观看`

          if (_result.collectStat) {
            this.liList[2].name = '取消收藏'
            this.liList[2].i = 'el-icon-star-on'
          } else {
            this.liList[2].name = '收藏课程'
            this.liList[2].i = 'el-icon-star-off'
          }

          this._collectStat = _result.collectStat
          return data
        })
        .catch(err => Promise.reject(err))
    },

    /**
     * 跳转文档详情
     */
    toPdfDetail(row) {
      const routeUrl = this.$router.resolve({
        path: '/pdfDetail',
        query: {
          datumId: row.datumId
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    /**
     * 跳转详情
     */
    toDetail(id) {
      const routeUrl = this.$router.resolve({
        path: '/video',
        query: {
          courseId: id
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    /**
     * 切换章节
     */
    handleChangeChapter(id) {
      // 当前章节
      const _currentCourseChapter = this.studyList.find(v => v.id === id) || {}

      this.chapterId = id
      this.currentCourseChapterName = _currentCourseChapter.name
      this._duration = _currentCourseChapter.duration
      this._player.src(_currentCourseChapter.url || '')
      this.$router.replace({
        path: '/video',
        query: {
          courseId: this.courseId,
          chapterId: this.chapterId
        }
      })
    },

    /**
     * 点击视频详情
     */
    onVideoInfo(index) {
      if (index === 2) {
        if (!YitongToken.get()) {
          gotoLogin()
          return
        }

        if (this._collectStat) {
          // 取消收藏

          $http
            .post('/yswx/gw/course/deleteCourseCollect', {
              courseId: this.courseId
            })
            .then(() => {
              this.liList[2].name = '收藏课程'
              this.liList[2].i = 'el-icon-star-off'
              this._collectStat = !this._collectStat
            })
        } else {
          // 收藏课程

          $http
            .post('/yswx/gw/course/addCourseCollect', {
              courseId: this.courseId
            })
            .then(() => {
              this.liList[2].name = '取消收藏'
              this.liList[2].i = 'el-icon-star-on'
              this._collectStat = !this._collectStat
            })
        }
      } else if (this.liList[index].name == '分享到') {
        this.studyType = true
      }
    },

    changePre(num) {
      const type = this.introduceTap[num].pre
      this.preType1 = false
      this.preType2 = false
      this.preType3 = false
      this[type] = true
    },

    changeDetail(num) {
      if (num === 1) {
        this.studyType = false
      } else {
        this.studyType = true
      }
    },

    changeTab(num, type) {
      this[type].forEach((item, index) => {
        item.className = ''
        if (index === num) {
          item.className = 'on'
        }
      })
      if (type === 'detailList') {
        this.changeDetail(num)
      }
      if (type === 'introduceTap') {
        this.changePre(num)
      }
    },

    /**
     * 设置评论人数
     */
    setReplyCount(val) {
      this.liList[1].name = `${val || 0}讨论`
    },

    /**
     * 获取相关课程
     */
    getCorrelatedList() {
      $http
        .post('/yswx/gw/videoCourse/getSimilarCourse', {
          // [搜索关键词]
          searchText: this.studyDetail.courseName,
          // [园所ID]
          // schoolId: '2980',
          // [分页数量]
          pageSize: 5,
          // [加载更多标识]
          next: ''
        })
        .then(data => {
          this.correlatedList = data.result.list || []
        })
        .catch(() => {})
    },

    /**
     * 获取 课程章节列表
     */
    getStudyList() {
      $http
        .post('/yswx/gw/videoCourse/getCourseChapterListForPC', {
          courseId: this.courseId
        })
        .then(data => {
          this.studyList = data.result.list || []
          if (this.studyList.length > 0) {
            const _chapterId = Number(this.$route.query.chapterId)

            if (isNaN(_chapterId)) {
              // 初次进入
              this.chapterId = this.studyList[0].id
              this.currentCourseChapterName = this.studyList[0].name
              this._duration = this.studyList[0].duration
              this.$router.replace({
                path: '/video',
                query: {
                  courseId: this.courseId,
                  chapterId: this.chapterId
                }
              })
            } else {
              // 刷新
              const _currentCourseChapter = this.studyList.find(
                v => v.id === _chapterId
              )
              this.chapterId = _chapterId
              this.currentCourseChapterName = _currentCourseChapter.name
              this._duration = _currentCourseChapter.duration
            }

            this._player = videojs('my-video', {})
            this._player.ready(() => {
              this._player.src(
                _chapterId
                  ? (() => {
                      const _temp = this.studyList.find(
                        v => v.id === _chapterId
                      )
                      return _temp ? _temp.url : ''
                    })() || ''
                  : this.studyList[0].url
              )

              this._player.on('play', () => {
                // console.log('------play----------', res)

                $http.LogForVideoStartTime = new Date().getTime()
                $http.LogForVideoCallback(
                  'videoStudyTimeV2ForPC',
                  'YTCollection',
                  this.courseId,
                  this.chapterId
                )
              })

              this._player.on('ended', () => {
                // console.log('------ended----------', res)

                clearInterval($http.LogForVideoTimer)
                $http.LogForVideo.maxTimeNode = this._duration
                $http.log($http.LogForVideo, {
                  courseId: this.courseId
                })
              })

              this._player.on('timeupdate', () => {
                // console.log('-------timeupdate---------', res)

                if (!$http.LogForVideo) return
                $http.LogForVideo.sum += 0.25
                $http.LogForVideo.maxTimeNode = Math.max(
                  this._player.currentTime(),
                  $http.LogForVideo.maxTimeNode
                )
                $http.LogForVideo.duration = this._duration
              })
            })
          }
        })
        .catch(() => {})
    },

    /**
     * 获取 相关资料列表
     */
    getPdfList() {
      $http
        .post('/yswx/gw/videoCourse/getCourseDatumForPC', {
          courseId: this.courseId
        })
        .then(data => {
          this.pdfList = data.result.list
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.g-video {
  color: #666;
}
.title {
  color: #3d3d3d;
  font-size: 24px;
  margin: 20px 0;
}
.downBody {
  display: flex;
  .correlated {
    width: 270px;
    margin-top: -40px;
    .titleP {
      margin-bottom: 20px;
      font-size: 16px;
    }
    .list-box {
      width: 100%;
      display: block;
      p {
        overflow: hidden; /*超出的部分隐藏起来。*/
        white-space: nowrap; /*不显示的地方用省略号...代替*/
        text-overflow: ellipsis; /* 支持 IE */
      }
    }
  }
  .introduce {
    flex: 1;
    pre {
      width: 840px;
      white-space: pre-wrap; /* css3.0 */
      white-space: -moz-pre-wrap; /* Firefox */
      white-space: -pre-wrap; /* Opera 4-6 */
      white-space: -o-pre-wrap; /* Opera 7 */
      word-wrap: break-word; /* Internet Explorer 5.5+ */
      font-size: 14px;
      font-family: inherit;
      margin: 40px 20px;
      line-height: 25px;
    }
    .teacher {
      margin: 60px 0;
      display: flex;
      .teacherImg {
        width: 320px;
        display: inline-block;
      }
      span {
        display: inline-block;
        margin-left: 60px;
        padding-right: 40px;
        border-right: 1px solid #ddd;
        width: 100px;
        vertical-align: middle;
        p {
          display: block;
          text-align: center;
          margin-bottom: 10px;
        }
        .p1 {
          font-weight: bold;
        }
      }
      .teacherP {
        flex: 0.9;
        display: inline-block;
      }
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }
    .introduceTab {
      line-height: 50px;
      width: 878px;
      color: #666;
      border: 1px solid #dfdfdf;
      background-color: #efefef;
      span {
        display: inline-block;
        width: 25%;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
      .on {
        border: 1px solid #dfdfdf;
        background-color: #fff;
        border-top: 2px solid #c4261d;
        border-bottom: 0;
        color: #c4261d;
      }
    }
  }
}
.videoInfo {
  margin: 30px 0 20px 0;
  .icoList {
    display: inline-block;
    span {
      margin-left: 10px;
    }
  }
  ul {
    li {
      display: inline-block;
      margin-right: 20px;
      font-size: 16px;
      color: #3d3d3d;
      line-height: 34px;
      cursor: pointer;
      i {
        color: #000;
        margin-right: 5px;
        font-size: 20px;
      }
    }
    li:hover {
      color: #c4261d;
    }
    .onLi {
      color: #c4261d;
    }
  }
}
.videoBox {
  background-color: #000;
  height: 573px;
  display: flex;
  .my-video {
    width: 876px;
    height: 100%;
    display: inline-block;
  }
  .detailList {
    // flex: 1;
    // display: inline-block;
    vertical-align: top;
    color: #fff;
    background-color: #303030;
    .tab {
      background-color: #000;
      span {
        display: inline-block;
        width: 80px;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
      }
      .on {
        background-color: #303030;
      }
    }
    .toPage {
      text-align: center;
      i {
        margin: 0 10px;
        cursor: pointer;
      }
    }
    .my-scroll-bar {
      width: 327px;
      height: 513px;

      p {
        overflow: hidden; /*超出的部分隐藏起来。*/
        white-space: nowrap; /*不显示的地方用省略号...代替*/
        text-overflow: ellipsis; /* 支持 IE */
      }
    }
    ul {
      li {
        width: 315px;
        height: 72px;
        margin: 2px 5px;
        padding-top: 16px;
        background-color: #3d3d3d;
        font-size: 12px;
        color: #bdbdbd;
        cursor: pointer;
        span {
          display: inline-block;
        }
        p {
          margin-bottom: 20px;
          font-size: 14px;
          padding-left: 4px;
          padding-right: 4px;
        }
        .time {
          margin-left: 10px;
        }
        .studyType {
          float: right;
          width: 66px;
          line-height: 20px;
          text-align: center;
          padding: 0 5px;
          background-color: #dfdfdf;
          color: #999;
          margin-right: 20px;
        }
        .pdfType {
          float: right;
          background-color: #dfdfdf;
          margin-right: 20px;
          .s1 {
            width: 28px;
            padding: 0 5px;
            text-align: center;
            color: #fff;
            background-color: #8f8f8f;
            line-height: 20px;
          }
          .s2 {
            width: 66px;
            text-align: center;
            padding: 0 5px;
            color: #999;
          }
        }
        &.active {
          background-color: #555;
        }
      }
      li:hover {
        background-color: #555;
      }
    }
  }
}
</style>